@use "@inshared/ui-foundation/css/tokens/breakpoints";
@use "@inshared/ui-foundation/css/tokens/color";
@use "@inshared/ui-foundation/css/tokens/spacing";

web-chatbot-small {
    display: flex;
    align-items: center;
    background: url("/assets/images/chat-shmuppet-80x100.png") no-repeat top left;
    background-size: auto 60px;
    padding-left: 50px;
    min-height: 50px;
    background-position-y: -5px;
    margin-top: -5px;

    web-accordion {
        --background-color: transparent;
        --border-width: 0;
        display: block;
        min-width: 500px;

        .accordion {
            & > button {
                padding: 0;
                margin: 0;
            }

            .accordion-content {
                padding: spacing.$md 0 0;
            }
        }
    }

    web-chatbot-input {
        .input-container {
            flex: 1 1;
        }

        .input {
            padding: 0;
            margin: 0;
        }
    }
}
